import { isAuthorized, getUserId } from 'utils/Auth'
import configpath from 'configpath'
import { createReducer } from '../utils'

export const GET_PERMISSION_REQUEST = 'sherrinford/impersonate/GET_PERMISSION_REQUEST'
export const GET_PERMISSION_SUCCESS = 'sherrinford/impersonate/GET_PERMISSION_SUCCESS'
export const GET_PERMISSION_FAILURE = 'sherrinford/impersonate/GET_PERMISSION_FAILURE'

const initialStates = {
  isLoading: false,
  data: {},
}

export default createReducer(initialStates, {
  [GET_PERMISSION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PERMISSION_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    data,
  }),
  [GET_PERMISSION_FAILURE]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const getPermission = (profileId, userEmail, profileSlug = '', typeDestination = '') => {
  const token = JSON.parse(isAuthorized())
  const data = {
    token,
    userId: JSON.parse(getUserId()),
    profileId,
    userEmail,
  }
  return {
    type: [
      GET_PERMISSION_REQUEST,
      GET_PERMISSION_SUCCESS,
      GET_PERMISSION_FAILURE,
    ],
    shuttle: {
      method: 'POST',
      path: '/auth/permission',
      authorization: `${token}`,
      payloads: data,
    },
    nextAction: (res, err) => {
      if (err) {
        return ''
      }
      if (typeDestination === 'project') {
        return window.open(`${configpath.wispHost}/access_super_user/${res.key}?urlProject=${profileId}/${profileSlug}`)
      }
      return window.open(`${configpath.wispHost}/${profileId}${profileSlug ? `/${profileSlug}` : ''}?adminKey=${res.key}`)
    },
  }
}
